const { isEmpty, keyBy, } = require('lodash');

// シミュレーションで変更できる対象。
// マスタのコレクションはそのまま読み、changes を重ねて表示する。
// products/suppliers/productTypes/productGroups はマスタ共有、
// orderCounts/inventoryCounts は過去実績の自動集計のため対象外。
const simulatedCollectionNames = [
  'purchaseOrders',
  'containers',
];

const collectionLabels = {
  purchaseOrders: 'PO',
  containers: 'コンテナ',
};

// changes に積む操作。id はマスタのドキュメントID(新規作成分はクライアント採番)
const changeTypes = {
  create: { label: '追加', color: 'success' },
  update: { label: '変更', color: 'warning' },
  delete: { label: '削除', color: 'danger' },
};

const changeKey = (collectionName, id) => [collectionName, id].join('/');

// 同じドキュメントへの操作は1件にまとめる。
// create したものを update したら create のまま値だけ更新し、
// create したものを delete したら操作自体を消す(マスタには元々無いため)
const applyChangeToList = (changes, change) => {
  const key = changeKey(change.collectionName, change.id);
  const existing = changes.find(_ => changeKey(_.collectionName, _.id) === key);
  const others = changes.filter(_ => changeKey(_.collectionName, _.id) !== key);

  if (change.type === 'delete') {
    // シミュレーション内で作ったものを消す場合は、変更ごと無かったことにする
    if (existing?.type === 'create') return others;
    return [...others, { ...change, values: null }];
  }
  if (existing?.type === 'create') {
    return [...others, { ...existing, values: { ...existing.values, ...change.values } }];
  }
  if (existing?.type === 'update') {
    return [...others, { ...existing, values: { ...existing.values, ...change.values } }];
  }
  return [...others, change];
};

const removeChangeFromList = (changes, collectionName, id) => {
  return changes.filter(_ => changeKey(_.collectionName, _.id) !== changeKey(collectionName, id));
};

// マスタの一覧に changes を重ねて、シミュレーション上の一覧を作る。
// 各画面はこの結果を使うだけでよい
const applyChanges = (masterItems, changes, collectionName) => {
  const relevant = (changes || []).filter(_ => _.collectionName === collectionName);
  if (isEmpty(relevant)) return masterItems;

  const changesById = keyBy(relevant, 'id');
  const deletedIds = new Set(relevant.filter(_ => _.type === 'delete').map(_ => _.id));
  const updated = masterItems
    .filter(_ => !deletedIds.has(_.id))
    .map((item) => {
      const change = changesById[item.id];
      return change?.type === 'update' ? { ...item, ...change.values, id: item.id, ref: item.ref } : item;
    });
  const created = relevant
    .filter(_ => _.type === 'create')
    .map(_ => ({ ..._.values, id: _.id, isSimulationCreated: true }));

  return [...updated, ...created];
};

module.exports = {
  simulatedCollectionNames,
  collectionLabels,
  changeTypes,
  changeKey,
  applyChangeToList,
  removeChangeFromList,
  applyChanges,
  fields: () => {
    return {
      name: {
        label: 'シミュレーション名',
        type: 'string',
        validations: { required: (v) => !isEmpty(v) },
      },
      note: {
        label: 'メモ',
        type: 'text',
        rows: 5,
      },
    };
  },
};
